var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "chart-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.toggleSort
    }
  }, [_c('v-icon', [_vm._v("mdi-sort")])], 1)], 1), _c('div', {
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('canvas', {
    ref: "canvas",
    attrs: {
      "height": _vm.height
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }